export const CARD_HEIGHT = 265;
